import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import { navigate } from "@gatsbyjs/reach-router";
import { AuthProvider, useAuthState } from "_ReactContext/AuthContext";
import useGetMetadata from "customHooks/useGetMetadata";
import { useListPageFunctionsDeleteApiKey } from "./components/useListPageFunctionsDeleteBranch";
import {
    useCompleoSimpleList,
    actionsTableListType,
    actionsTableFunction
} from "customHooks/useCompleoSimpleList";
import { Button, Icon } from "@material-ui/core";
import { useGlobalDialog } from "_ReactContext/GlobalDialogContext";
import { apiDirectCall, useApiCache } from "customHooks/useApi";
import useShowMessage from "customHooks/useShowMessage/useShowMessage";
import ModalNewApiKey from "./components/ModalNewApiKey";

const actionsTable = (
    listPageFunctions: Compleo.IObject[],
    t: any,
    disableDelete: boolean
) => {
    return (refreshListFunction: any) => {
        const result: actionsTableListType = [
            {
                icon: "delete",
                tooltip: t("COMPLEOGENERAL_Delete"),
                onClick: (event: any, rowData: any) => {
                    // console.log("clique no delete");
                    if (listPageFunctions.length > 0) {
                        listPageFunctions[0].fn(rowData).then(
                            (resolve: boolean) => {
                                if (resolve) {
                                    refreshListFunction();
                                }
                            },
                            (reject: boolean) => {
                                console.log(
                                    "reject return do callDialog",
                                    reject
                                );
                            }
                        );
                    }
                },
                hidden: disableDelete
            }
        ];

        return result;
    };
};

const ManageApiKeysList = (props: any) => {
    const [t, i18n, readyTranslation] = useTranslation("APIKEYSLIST", {
        useSuspense: false
    });
    const [metadata] = useGetMetadata("APIKEYSLIST");
    const listAddress = "/api-keys/manage-api-keys-list";
    const { company } = useAuthState();
    const [open, setOpen] = React.useState(false);

    const listPageFunctions = useListPageFunctionsDeleteApiKey(
        t,
        company.companyId
    );

    const actions: actionsTableFunction = actionsTable(
        listPageFunctions,
        t,
        false
    );

    const [renderTable, finished] = useCompleoSimpleList(
        t,
        metadata,
        listAddress,
        "post",
        {
            companyId: company.companyId
        },
        actions
    );

    let compRetorno: null | JSX.Element = <Loading />;
    if (readyTranslation && finished) {
        compRetorno = renderTable();
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="xl"
                RightButtonComponent={
                    <>
                        <Button
                            onClick={() => setOpen(true)}
                            startIcon={<Icon>add</Icon>}
                            variant="outlined"
                            size="small"
                            color="primary"
                        >
                            {t("buttonTopRight")}
                        </Button>
                    </>
                }
            >
                {open && (
                    <ModalNewApiKey
                        open={open}
                        onClose={() => {
                            setOpen(false);
                        }}
                    />
                )}
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default ManageApiKeysList;
